<template>
  <div class="wrapper">
    <div class="filter white_box">
      <!-- 选择&搜索框 -->
      <el-input class="custom-es" size="medium" placeholder="请输入通知标题" v-model="Title" clearable></el-input>
      <!-- 搜索框 -->
      <p class="font_14_black">选择接收时间：</p>
      <el-date-picker  v-model="dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      <!-- 查询&重置按钮 -->
      <button-a color="#f26828" class="query" @click.native="query()">查询</button-a>
      <button-a color="#08a752" @click.native="reset()">重置</button-a>
    </div>

    <div class="result white_box">
      <!-- 标签筛选 -->
      <div class="tags white_box">
        <div class="tag-group">
          <p class="font_14_black">请选择通知类型：</p>
          <filter-tag
            :class="{active: MessageTypes[1]}"
            @click.native="change('MessageTypes', 1)"
            name="系统消息"
          />
          <filter-tag
            :class="{active: MessageTypes[2]}"
            @click.native="change('MessageTypes', 2)"
            name="政策公告"
          />
          <filter-tag
            :class="{active: MessageTypes[3]}"
            @click.native="change('MessageTypes', 3)"
            name="协议到期"
          />
          <filter-tag
            :class="{active: MessageTypes[4]}"
            @click.native="change('MessageTypes', 4)"
            name="员工合同到期"
          />
          <filter-tag
            :class="{active: MessageTypes[5]}"
            @click.native="change('MessageTypes', 5)"
            name="报表生成"
          />
        </div>
        <div class="tag-group">
          <p class="font_14_black">请选择是否已读：</p>
          <filter-tag
            :class="{active: ReadState[0]}"
            @click.native="change('ReadState', 0)"
            name="已读"
          />
          <filter-tag
            :class="{active: ReadState[1]}"
            @click.native="change('ReadState', 1)"
            name="未读"
          />
          <!-- 操作选项 -->
          <div class="options">
            <div>
              <button-a @click.native="toSetting()" color="#05b8fe">通知设置</button-a>
              <button-a @click.native="operate('readed')" color="#f26828">标记已读</button-a>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格
        ref="multipleTable" 引用名
        :data="tableData" 绑定数据
        tooltip-effect 鼠标hover提示效果
        :header-row-style 表头样式
        :header-cell-style 表头单元格样式
        :row-style="rowStyle" 行样式
      -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        @selection-change="handleSelectionChange"
        tooltip-effect="dark"
        :header-row-style="{height: translateWidth(68)+'px', fongSize: '14px', color: '#000', backgroundColor: '#fafbff'}"
        :header-cell-style="{backgroundColor: 'transparent'}"
        :row-style="{height: translateWidth(60)+'px', backgroundColor: '#fff'}"
        style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblclick"
        @row-mousedown="handleRowMousedown"
        @row-mousemove="handleRowMousemove"
        @row-mouseup="handleRowMouseup"
      >
        <!-- 表格行
          type="index" 指定为索引列
          label 列名
          prop 指定内容对应的属性键名
          show-overflow-tooltip 当内容过长被隐藏时显示tooltip
          需要根据prop进行计算渲染时，不指定prop，使用template，其slot-scope="scope"获取此行数据
        -->
        <!-- 占位列 -->
        <el-table-column :width="35 | translateWidth"></el-table-column>
        <!-- 多选框 -->
        <el-table-column type="selection" :width="66 | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column type="index" label="序号" :width="94 | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="{ 'font-bold': !scope.row.isReaded }">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="messageType"
          label="通知类型"
          :width="160 | translateWidth"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span :class="{ 'font-bold': !scope.row.isReaded }">{{ getMessageTypeText(scope.row.messageType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="通知标题"
          :width="360 | translateWidth"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span :class="{ 'font-bold': !scope.row.isReaded }">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="接收时间" :width="250 | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope"><span :class="{ 'font-bold': !scope.row.isReaded }">{{date(scope.row.creationTime)}}</span></template>
        </el-table-column>
        <el-table-column label="是否已读" :width="182 | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              <!-- {{scope.row.isReaded === true ? "已读" : "未读"}} -->
              <span class="red_point font-bold" v-show="!scope.row.isReaded">未读</span>
              <span v-show="scope.row.isReaded">已读</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="font_14_orange pointer view" :class="{ 'font-bold': !scope.row.isReaded }" @click="view((scope.row))">通知详情</span>
            <span class="font_14_gray pointer view" :class="{ 'font-bold': !scope.row.isReaded }" @click.stop="viewTheBusiness((scope.row))">业务查看</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- 
        hide-on-single-page Boolean，只有一页时隐藏
        :current-page="page" 绑定当前页码
        @size-change="handleSizeChange" 每页条数改变回调
        @current-change="handleCurrentChange" 当前页码改变回调
        layout="total, prev, pager, next, sizes, jumper, ->, slot" 显示选项
          total 总条数
          prev 前一页
          pager 页码
          next 后一页
          sizes 每页条数
          jumper 输入并跳转某页
          -> 
          slot 自定义内容
      -->
      <el-pagination
        ref="pagination"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, sizes, jumper, ->, slot"
        :total="total"
        :pager-count="5"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { Get, Patch } from "@/js/http.js";
import { Filter, dateConvert, translateWidth } from "@/js/tool.js";

export default {
  name: "Message",
  components: {},
  props: {},
  data() {
    return {
      Title: "", // 通知标题输入
      MessageTypes: {
        // 消息类型
       1: true, // 系统消息
        2: true, // 政策公告
       3: true, // 协议到期
        4: true, // 员工合同到期
       5: true // 报表生成
      },
      ReadState: {
        // 是否已读
        0: this.$route.params.hasOwnProperty("unread")
          ? this.$route.params.unread
          : true, // 已读
        1: true // 未读
      },
      dateRange: [], // 日期时间范围
      page: 1, // 当前页码
      size: 10, // 每页条数
      total: 0, // 总条数
      tableData: [], // 表格数据

      selectRows: [],

      disabled: "", // 禁止修改的开关
      
      // 交互相关
      clickTimer: null, // 单击定时器
      isDragging: false, // 是否正在拖动
      isDoubleClick: false // 是否双击
    };
  },
  watch: {},
  computed: {
    // 查询表格跳过的条数
    SkipCount() {
      return (this.page - 1) * this.size;
    },
    // 选择的通知id
    selectIdList() {
      return this.selectRows.map(item => item.id);
    },
    // 开始时间
    EffectTimeStart() {
      if (this.dateRange && this.dateRange.length > 0) {
        // 确保日期格式正确，避免出现类似"YYYY-02-00"这样的无效日期
        let startDate = this.dateRange[0];
        // 将格式从"yyyy-MM-dd HH:mm:ss"转换为"yyyy-MM-dd'T'HH:mm:ss'Z'"
        if (startDate) {
          return startDate.replace(' ', 'T') + 'Z';
        }
        return startDate;
      } else {
        return "";
      }
    },
    // 结束时间
    EffectTimeEnd() {
      if (this.dateRange && this.dateRange.length > 1) {
        // 确保日期格式正确，避免出现类似"YYYY-02-00"这样的无效日期
        let endDate = this.dateRange[1];
        // 将格式从"yyyy-MM-dd HH:mm:ss"转换为"yyyy-MM-dd'T'HH:mm:ss'Z'"
        if (endDate) {
          return endDate.replace(' ', 'T') + 'Z';
        }
        return endDate;
      } else {
        return "";
      }
    }
  },
  methods: {
    // 获取表格数据
    getData() {
      let ReadState = [];
      // 两者都选时传递空数组（显示所有）
      if (!(this.ReadState[0] && this.ReadState[1])) {
        if (this.ReadState[0]) {
          ReadState.push(true);
        }
        if (this.ReadState[1]) {
          ReadState.push(false);
        }
      }
      let MessageTypes = [];
      if (this.MessageTypes[1]) {
        MessageTypes.push(1);
      }
      if (this.MessageTypes[2]) {
        MessageTypes.push(2);
      }
      if (this.MessageTypes[3]) {
        MessageTypes.push(3);
      }
      if (this.MessageTypes[4]) {
        MessageTypes.push(4);
      }
      if (this.MessageTypes[5]) {
        MessageTypes.push(5);
      }
      Get("api/v1/messages", {
        Title: this.Title || "", // 通知标题
        MessageTypes: MessageTypes, //消息类型
        ReceiveBeginTime: this.EffectTimeStart, // 开始时间
        ReceiveEndTime: this.EffectTimeEnd, //结束时间
        ReadStates: ReadState, //是否已读
        MaxResultCount: this.size, // 每页条数
        SkipCount: this.SkipCount // 跳过条数
      })
        .then(res => {
          this.total = res.data.totalCount;
          this.tableData = res.data.items;
        })
        .catch(() => {});
    },
    // 点击查询按钮
    query() {
      this.page = 1;
      this.getData();
    },
    // 重置
    reset() {
      this.Title = "";
      this.dateRange = [];
      // 重置通知类型和已读状态为全选
      for (let key in this.MessageTypes) {
        this.MessageTypes[key] = true;
      }
      for (let key in this.ReadState) {
        this.ReadState[key] = true;
      }
      this.query();
    },
    // 点击筛选标签，刷新dataName对象 dataName: String，对象名; key: Number/String
    change(dataName, key) {
      let ischanged = Filter.call(this, dataName, key);
      if (ischanged) {
        this.page = 1;
        this.getData();
      }
    },
    // 每页条数选择
    handleSizeChange(v) {
      this.size = v;
      this.getData();
    },
    // 页码选择
    handleCurrentChange(v) {
      this.page = v;
      this.getData();
    },
    // 日期格式转换
    date(dateStr) {
      return dateConvert(dateStr, {
        format: "Y-M-D H:MIN:S"
      });
    },
    // 显示对话框
    dialog() {
      this.mask = !this.mask;
    },
    // 处理行点击（支持双击取消跳转、拖动选中不跳转）
    handleRowClick(item) {
      if (this.isDragging || this.isDoubleClick) {
        this.isDoubleClick = false;
        return;
      }
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }
      this.clickTimer = setTimeout(() => {
        this.view(item);
        this.clickTimer = null;
      }, 300);
    },
    // 处理双击
    handleRowDblclick(item) {
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
      }
      this.isDoubleClick = true;
      this.copyRowData(item);
    },
    // 处理鼠标按下
    handleRowMousedown() {
      this.isDragging = false;
    },
    // 处理鼠标移动
    handleRowMousemove() {
      this.isDragging = true;
    },
    // 处理鼠标释放
    handleRowMouseup() {
      setTimeout(() => {
        this.isDragging = false;
      }, 100);
    },
    // 复制行数据文本
    copyRowData(item) {
      const rowText = `通知类型: ${this.getMessageTypeText(item.messageType) || ''}\n通知标题: ${item.title || ''}\n接收时间: ${this.date(item.creationTime) || ''}\n是否已读: ${item.isReaded ? '已读' : '未读'}`;
      
      navigator.clipboard.writeText(rowText).then(() => {
        this.$message.success('已复制整行数据');
      }).catch(() => {
        const textarea = document.createElement('textarea');
        textarea.value = rowText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('已复制整行数据');
      });
    },
    // 查看详情
    view(item) {
      // 标记为已读
      Patch(
        "api/v1/messages/read-state",
        {
          pkIds: [item.id],
          isRead: true
        }
      )
        .then(() => {
          this.getData();
          this.getUnreadNum();
        })
        .catch(() => {});
      this.$router.push({
        name: "MessageItem",
        params: { id: item.id }
      });
    },
    // 业务查看
    viewTheBusiness(item) {
      // 标记为已读
      Patch(
        "api/v1/messages/read-state",
        {
          pkIds: [item.id],
          isRead: true
        }
      )
        .then(() => {
          this.getData();
          this.getUnreadNum();
        })
        .catch(() => {});
      
      const messageType = parseInt(item.messageType) || parseInt(item.msgType);
      const linkUrl = item.linkUrl || item.url || '';
      
      // 判断并跳转
      if (messageType === 1) {
        // 系统消息
        this.$router.push({ name: "TimeLine" });
      } else if (messageType === 2) {
        // 政策公告 - 打开政策公告页面
        this.$router.push({ name: "Policy", params: { noticeID: linkUrl } });
      } else if (messageType === 3) {
        // 协议到期 - 打开对应客户的企业信息页面
        this.$router.push({ name: "UserInfo", params: { customerId: linkUrl } });
      } else if (messageType === 4) {
        // 员工合同到期 - 打开员工合同详情页面
        this.$router.push({ name: "EmployeeContractItem", params: { id: linkUrl } });
      } else if (messageType === 5) {
        // 报表通知 - 打开用工数据报表页面
        this.$router.push({ name: "EmploymentData" });
      } else if (messageType === 6) {
        // 员工信息 - 打开员工信息详情页面
        this.$router.push({ name: "EmployeeInfoItem", params: { id: linkUrl } });
      } else if (messageType === 7) {
        // 薪资详情 - 打开薪资详情页面
        this.$router.push({ name: "SalaryDetailsItem", params: { pkid: linkUrl, setType: '1' } });
      } else if (linkUrl) {
        // 如果有链接但类型不匹配，直接跳转
        if (linkUrl.startsWith('http')) {
          window.open(linkUrl, '_blank');
        } else {
          this.$router.push({ path: linkUrl });
        }
      } else {
        // 默认跳转首页
        this.$router.push({ name: "Home" });
      }
    },
    // 表格行选择
    handleSelectionChange(value) {
      this.selectRows = value;
    },
    // 操作
    operate(type) {
      // 检查是否有选中的条目
      if (this.selectRows.length === 0) {
        this.$message({
          message: '请选择需要操作的消息',
          type: 'warning'
        });
        return;
      }
      
      if (type === "readed") {
        let isRead = true;
        Patch(
          "api/v1/messages/read-state",
          {
            pkIds: this.selectIdList,
            isRead: isRead
          }
        )
          .then(() => {
            this.getData();
            this.getUnreadNum();
          })
          .catch(() => {});
      }
    },
    getUnreadNum() {
      Get("api/v1/global/messages/unread")
        .then(res => {
          localStorage.setItem("unreadNum", res.data); // local存储未读信息数量
          this.$store.state.unreadNum = res.data;
        })
        .catch(() => {});
    },
    // 跳转到设置
    toSetting() {
      this.$router.push({ name: "MessageSettings" });
    },
    // 获取通知类型文字
    getMessageTypeText(type) {
      switch (type) {
        case 1:
          return "系统消息";
        case 2:
          return "政策公告";
        case 3:
          return "协议到期";
        case 4:
          return "员工合同到期";
        case 5:
          return "报表生成";
        default:
          return "未知类型";
      }
    },
    translateWidth(num) {
      return translateWidth(num);
    }
  },
  created() {},
  mounted() {
    this.getData();
  },
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 150px 32px 24px;
  > div {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .filter {
    display: flex;
    align-items: center;
    padding: 22px 48px;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 0;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-width: calc(100% - 11.6vw);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
  }
  .tags {
    padding: 48px;
    .tag-group {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .options {
      flex: 1;
      div {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .sum-group {
    display: flex;
    padding: 24px 48px 24px;
    align-items: center;
    .sum {
      width: 240px;
      &:last-of-type {
        flex: 1;
      }
    }
  }
  .result {
    padding: 30px 48px 48px;
  }
}
/** 
  补充样式
*/
// 筛选标签
.filter-tag {
  margin-left: 6px;
  margin-right: 24px;
}
// 查询按钮
.query {
  margin-left: 70px;
  margin-right: 32px;
}
// 导出按钮
.export {
  margin-right: 50px;
}
// 查看按钮
.view {
  margin-right: 18px;
}
// 通知详情按钮
.detail {
  margin-right: 18px;
}

// 小标签
.tag {
  margin-left: 16px;
}

// 未读通知加粗
.font-bold {
  font-weight: bold;
}

// 补充样式
.wrapper .tags .tag-group[data-v-1fac0bb6]:last-child {
  margin-bottom: 0px;
  margin-left: -45px;
  margin-top: -35px;
}
.red_point {
  position: relative;
}
.red_point::after {
  position: absolute;
  content: "";
  right: -8px;
  top: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f26828;
}
.custom-mc.el-date-editor {
  margin-right: 10px;
}
.save_btn {
  margin-top: 40px;
}
</style>